import { render, staticRenderFns } from "./LogForm.vue?vue&type=template&id=6fb8abe8&scoped=true"
import script from "./LogForm.vue?vue&type=script&lang=js"
export * from "./LogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8abe8",
  null
  
)

export default component.exports